import classNames from 'classnames';
import { LinkProps } from 'react-router-dom';

import { Link } from '@ui/Link';

import s from './Pagination.sss';

export type PaginationProps = {
  currentPage: number;
  totalPages: number;
  /** Function that returns url on page according to number. */
  hrefBuilder: (pageNumber: number) => string | LinkProps['to'];
  /**
   * How much pages show before and after current page
   * @default 2
   */
  pagesCount?: number;
  showEndPages?: boolean
  className?: string;
};

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  hrefBuilder,
  pagesCount = 2,
  showEndPages = true,
  className,
}) => {
  let startPage = 1;

  // If current page in the middle or in the right part of pagination block
  if (currentPage > pagesCount + 1) {
    // If current page is last `pagesCount` of `totalPages`
    if (currentPage + pagesCount > totalPages) {
      startPage = (
        2 * pagesCount >= totalPages
          ? 1
          : totalPages - 2 * pagesCount
      );
    } else {
      // If in the middle
      startPage = currentPage - pagesCount;
    }
  }

  let endPage = (
    startPage + pagesCount * 2 > totalPages
      ? totalPages
      : startPage + pagesCount * 2
  );

  let firstPageLink = null;
  let lastPageLink = null;
  if (showEndPages) {
    if (startPage === 2) {
      startPage -= 1;
    } else if (startPage > 2) {
      firstPageLink = (
        <>
          <Link
            className={classNames(s.cell, s.page, s.edgePageGroup)}
            to={hrefBuilder(1)}
          >
            1
          </Link>
          <div
            className={classNames(s.cell, s.delimiter, s.edgePageGroup)}
          >
            ...
          </div>
        </>
      );
    }

    if (endPage === totalPages - 1) {
      endPage += 1;
    } else if (endPage < totalPages - 1) {
      lastPageLink = (
        <>
          <div
            className={classNames(s.cell, s.delimiter, s.edgePageGroup)}
          >
            ...
          </div>
          <Link
            className={classNames(s.cell, s.page, s.edgePageGroup)}
            to={hrefBuilder(totalPages)}
          >
            {totalPages}
          </Link>
        </>
      );
    }
  }

  const cells = [];
  for (let i = startPage; i <= endPage; i += 1) {
    if (currentPage === i) {
      cells.push(
        <div key={i} className={classNames(s.cell, s.active)}>
          {i}
        </div>,
      );
    } else {
      cells.push(
        <Link key={i} className={classNames(s.cell, s.page)} to={hrefBuilder(i)}>
          {i}
        </Link>,
      );
    }
  }

  return (
    <div className={classNames(s.root, className)}>
      {
        currentPage > 1 && (
          <Link
            className={classNames(
              s.cell,
              s.backButton,
            )}
            to={hrefBuilder(currentPage - 1)}
          >
            <div className={s.buttonArrow}>&lt;</div>
            <div className={s.backButtonText}>Назад</div>
          </Link>
        )
      }

      {firstPageLink}

      {cells}

      {lastPageLink}

      {
        currentPage < totalPages && (
          <Link
            className={classNames(
              s.cell,
              s.nextButton,
            )}
            to={hrefBuilder(currentPage + 1)}
          >
            <div className={s.nextButtonText}>Вперед</div>
            <div className={s.buttonArrow}>&gt;</div>
          </Link>
        )
      }
    </div>
  );
};

export default Pagination;
